import {useSelector, shallowEqual} from 'react-redux';
import {currentRoomData as currentRoomDataSelectorFn} from '@stencil/hotels-cg-reducer/src/details/selectors';

const useCurrentRoomData = () => {
  const currentRoomData = useSelector(currentRoomDataSelectorFn, shallowEqual);
  return currentRoomData;
};

export default useCurrentRoomData;
